document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('[data-product-gallery-upgraded]');

  galleries.forEach((gallery) => {
    const main = gallery.querySelector('.pg-main');
    const allSlides = Array.from(gallery.querySelectorAll('.pg-slide'));
    const realSlides = allSlides.filter((slide) => !slide.dataset.clone);
    const dots = Array.from(gallery.querySelectorAll('.pg-dot'));
    const thumbs = Array.from(gallery.querySelectorAll('.pg-thumb'));
    const prevBtn = gallery.querySelector('[data-pg-prev]');
    const nextBtn = gallery.querySelector('[data-pg-next]');
    const counterCurrent = gallery.querySelector('[data-pg-current]');
    const counterTotal = gallery.querySelector('[data-pg-total]');
    const scrollThumb = gallery.querySelector('[data-pg-scroll-thumb]');
    const desktopQuery = window.matchMedia('(min-width: 750px)');

    if (!main || !realSlides.length) return;

    let activeIndex = 0;
    let isAnimating = false;
    let animationTimer = null;

    if (counterTotal) {
      counterTotal.textContent = realSlides.length;
    }

    const mod = (n, m) => ((n % m) + m) % m;

    const isDesktop = () => desktopQuery.matches;

    const getAxisOffset = (slide) => {
      if (!slide) return 0;
      return isDesktop() ? slide.offsetTop : slide.offsetLeft;
    };

    const getAxisScroll = () => (isDesktop() ? main.scrollTop : main.scrollLeft);

    const setAxisScroll = (value, behavior) => {
      if (isDesktop()) {
        main.scrollTo({ top: value, behavior });
      } else {
        main.scrollTo({ left: value, behavior });
      }
    };

    const scrollThumbIntoView = (thumb) => {
      if (!thumb) return;
      thumb.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    };

    const updateRail = () => {
      if (!scrollThumb || !isDesktop()) return;

      const maxScroll = Math.max(main.scrollHeight - main.clientHeight, 0);
      const trackHeight = 188 - 20;
      const visibleRatio =
        main.scrollHeight > 0 ? Math.min(main.clientHeight / main.scrollHeight, 1) : 1;
      const thumbHeight = Math.max(trackHeight * visibleRatio, 42);
      const progress = maxScroll > 0 ? main.scrollTop / maxScroll : 0;
      const maxThumbTravel = Math.max(trackHeight - thumbHeight, 0);

      scrollThumb.style.height = `${thumbHeight}px`;
      scrollThumb.style.transform = `translate(-50%, ${progress * maxThumbTravel}px)`;
    };

    const updateUI = (realIndex) => {
      activeIndex = mod(realIndex, realSlides.length);

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      thumbs.forEach((thumb, index) => {
        const isActive = index === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
          if (!isDesktop()) {
            scrollThumbIntoView(thumb);
          }
        } else {
          thumb.removeAttribute('aria-current');
        }
      });

      if (counterCurrent) {
        counterCurrent.textContent = activeIndex + 1;
      }

      updateRail();
    };

    const jumpToIndex = (realIndex) => {
      const safeIndex = mod(realIndex, realSlides.length);
      const target = realSlides[safeIndex];
      if (!target) return;

      setAxisScroll(getAxisOffset(target), 'auto');
      updateUI(safeIndex);
    };

    const animateToIndex = (realIndex) => {
      const safeIndex = mod(realIndex, realSlides.length);
      const target = realSlides[safeIndex];
      if (!target) return;

      isAnimating = true;
      window.clearTimeout(animationTimer);
      setAxisScroll(getAxisOffset(target), 'smooth');
      updateUI(safeIndex);

      animationTimer = window.setTimeout(() => {
        isAnimating = false;
        updateRail();
      }, 360);
    };

    const goNext = () => {
      animateToIndex(Math.min(activeIndex + 1, realSlides.length - 1));
    };

    const goPrev = () => {
      animateToIndex(Math.max(activeIndex - 1, 0));
    };

    const syncNearestSlide = () => {
      let nearestIndex = 0;
      let nearestDistance = Infinity;
      const currentScroll = getAxisScroll();

      realSlides.forEach((slide, index) => {
        const distance = Math.abs(getAxisOffset(slide) - currentScroll);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      updateUI(nearestIndex);
    };

    main.addEventListener(
      'scroll',
      () => {
        updateRail();
        if (isAnimating) return;
        syncNearestSlide();
      },
      { passive: true }
    );

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        animateToIndex(index);
      });
    });

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        animateToIndex(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', goPrev);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', goNext);
    }

    gallery.addEventListener('keydown', (event) => {
      const isInsideGallery = gallery.contains(document.activeElement);
      if (!isInsideGallery) return;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        goNext();
      }

      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        goPrev();
      }
    });

    const initialSlide =
      realSlides.find((slide) => slide.classList.contains('is-initial-active')) || realSlides[0];
    const initialIndex = parseInt(initialSlide.dataset.realIndex || '0', 10) || 0;
    jumpToIndex(initialIndex);

    const variantInputSelectors = [
      'input[type="radio"][name^="options"]',
      'select[name^="options"]',
      'input[name="id"]'
    ];

    const variantInputs = gallery
      .closest('product-info')
      ?.querySelectorAll(variantInputSelectors.join(', '));

    if (variantInputs && variantInputs.length) {
      variantInputs.forEach((input) => {
        input.addEventListener('change', () => {
          window.setTimeout(() => {
            const initialActive = realSlides.find((slide) =>
              slide.classList.contains('is-initial-active')
            );

            if (initialActive) {
              const index = parseInt(initialActive.dataset.realIndex || '0', 10) || 0;
              jumpToIndex(index);
            }
          }, 120);
        });
      });
    }

    const onResize = () => {
      window.setTimeout(() => {
        jumpToIndex(activeIndex);
      }, 120);
    };

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', onResize);
    }

    window.addEventListener('resize', onResize);
  });
});
